import CitySvg from "@icons/city.svg?react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Company, useCompany } from "@/common/providers/company-provider";

const CompanyMenu = () => {
  const { company: activeCompany, companies: allCompanies } = useCompany();
  const avaiableCompanies = allCompanies.filter(
    (c) => c.id !== activeCompany?.id,
  );
  const navigate = useNavigate();

  const handleCompanySwitch = async (company: Company) => {
    await navigate("/switch-company", {
      replace: true,
      state: { company },
    });
  };

  return (
    <>
      {avaiableCompanies.map((company) => {
        return (
          <li key={company.id}>
            <button
              className="flex gap-x-4 p-6 text-can-forest-teal"
              onClick={() => handleCompanySwitch(company)}
            >
              <CitySvg className="h-6 w-6 flex-shrink-0" />
              <span className="text-left">{company.name}</span>
            </button>
          </li>
        );
      })}
    </>
  );
};

const Desktop = ({ children }: React.PropsWithChildren) => (
  <ul
    className="flex flex-col rounded-2xl mt-10 border bg-white font-bold text-can-forest-teal shadow-can-light-box"
    data-testid="company-menu"
  >
    {children}
  </ul>
);

const Mobile = ({ children }: React.PropsWithChildren) => (
  <ul
    className="flex flex-col gap-2 [&>li>button]:gap-x-2"
    data-testid="company-menu"
  >
    {children}
  </ul>
);

CompanyMenu.Desktop = Desktop;
CompanyMenu.Mobile = Mobile;

export { CompanyMenu };
